import {List, ListItem, ListItemIcon, ListItemText, Typography} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import Endpoints from "constants/Endpoints";
import React, {useState} from "react";
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import Loading from "components/Loading";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {makeStyles} from "@material-ui/styles";
import PapersGeneratorService from "services/PapersGeneratorService";
import WorkableIcon from "components/button/WorkableIcon";
import useSnackbar from "hooks/useSnackbar";

const useStyle = makeStyles(theme => ({
    loading: {
        width: '92%'
    },
}))
const PapersGeneratorSelectPopup = (
    {
        paperId,
        list,
        title,
        onClose,
        onSelect,
        onBack,
        selectGeneratesDocument,
        working,
        shareSystem
    }) => {

    const classes = useStyle();
    const [workingSupplier, setWorkingSupplier] = useState(0);
    const {enqueueSuccessSnackbar} = useSnackbar();
    const paperClick = (supplier) => {
        if (workingSupplier > 0)
            return;

        setWorkingSupplier(supplier.id);

        if(!!shareSystem) {
            PapersGeneratorService.sharePaper(supplier.id, paperId, shareSystem).then(resp => resp ? enqueueSuccessSnackbar(Tr("int_upload_success_x", {x: shareSystem}, true)) : null).finally(onClose)
        } else {
            PapersGeneratorService.downloadPaper(Endpoints.PAPERS_GENERATOR_PRINT(supplier.id, paperId), () => setWorkingSupplier(0), () => setWorkingSupplier(0))

        }
    }

    const getButtons = () => {
        const buttons = [];
        if (!!onBack) {
            buttons.push(createButton(Tr('back'), onBack, 'outlined'));
        }
        buttons.push(createButton(Tr('close'), onClose, undefined, working));
        return buttons;
    }

    const rowClick = (supplier) => {
        if (working)
            return;
        onSelect ? onSelect(supplier) : paperClick(supplier)
    }

    return (<Dialog
        title={title}
        open
        maxWidth='md'
        onClose={onClose}
        dialogActions={<MultiButton buttons={getButtons()}/>}
    >
        {(working || !list) && <Loading className={classes.loading}/>}
        {(!!list && list.length > 0) && <List dense>
            {list.map((supplier) =>
                <ListItem disabled={working} key={supplier.id} button onClick={() => rowClick(supplier)}>
                    <ListItemIcon>
                        <WorkableIcon
                            Icon={!!onSelect && !selectGeneratesDocument ? ExitToAppIcon : PrintIcon}
                            working={workingSupplier === supplier.id}/>
                    </ListItemIcon>
                    <ListItemText primary={supplier.name}/>
                </ListItem>)}
        </List>}
        {(!!list && list.length === 0) && <Typography>{Tr('no_options')}</Typography>}
    </Dialog>)
}

export default PapersGeneratorSelectPopup;